module.exports = __webpack_public_path__ + "static/media/ai-tips-icon_new.533259a1.svg";